<div class="bg-keyboard-background border-t flex w-full lg:px-32">
  @if(inputType() === 'text') {
    <ng-container *ngTemplateOutlet="text"></ng-container>
  } @else if (inputType() === 'number' || inputType() === 'decimal') {
    <ng-container *ngTemplateOutlet="numpad"></ng-container>
  } @else if (inputType() === 'full') {
    <ng-container *ngTemplateOutlet="text"></ng-container>
    <ng-container *ngTemplateOutlet="numpad"></ng-container>
  }
</div>

<ng-template #text>
  <div class="flex flex-col gap-2 p-2 flex-[4]">
    <!-- Keyboard Row 1 -->
    <div
      class="grid gap-2 h-14"
      [class]="columns() === 10 ? 'grid-cols-10' : 'grid-cols-11'"
    >
      @for (key of displayedRows()[0]; track $index) {
        <button
          (click)="keyPress(key)"
          class="bg-surface rounded-md shadow hover:bg-hover flex items-center justify-center py-2"
        >
          {{ key }}
        </button>
      }
    </div>

    <!-- Keyboard Row 2 -->
    <div
      class="grid gap-2 h-14"
      [class]="columns() === 10 ? 'grid-cols-10' : 'grid-cols-11'"
    >
      @for (key of displayedRows()[1]; track $index) {
        <button
          (click)="keyPress(key)"
          class="bg-surface rounded-md shadow hover:bg-hover flex items-center justify-center py-2"
        >
          {{ key }}
        </button>
      }
    </div>

    <!-- Keyboard Row 3 -->
    <div class="grid gap-2 grid-cols-11 h-14">
      @if (!isNumericMode()) {
        <button
          (click)="
            isShiftActive() || isCapsLockActive()
              ? resetShiftAndCapsLock()
              : toggleShift()
          "
          (dblclick)="toggleCapsLock()"
          class="rounded-md shadow hover:bg-hover flex items-center justify-center py-2 col-span-2 mr-2"
          [ngClass]="
            !isCapsLockActive() && !isShiftActive() ? 'bg-surface-tertiary' : 'bg-surface'
          "
        >
          @if (isShiftActive()) {
            <soft-icon name="fa-square-up fa-regular"></soft-icon>
          } @else if (isCapsLockActive()) {
          <soft-icon name="fa-square-up fa-solid"></soft-icon>
        } @else {
          <soft-icon name="fa-square-chevron-up fa-regular"></soft-icon>
        }
        </button>
      } @else {
      <button
        (click)="toggleSymbolMode()"
        class="bg-keyboard-functions rounded-md shadow hover:bg-hover flex items-center justify-center py-2 col-span-2 mr-2"
      >
        {{ isSymbolMode() ? 'ABC' : '#+-' }}
      </button>
    }

      <div class="col-span-7 grid grid-cols-7 gap-2">
        @if (columns() === 10) {
          <div>&nbsp;</div>
        }
        @for (key of displayedRows()[2]; track $index) {
          <button
            (click)="keyPress(key)"
            class="bg-surface rounded-md shadow hover:bg-hover flex items-center justify-center py-2"
          >
            {{ key }}
          </button>
        }
      </div>

      <button
        (click)="keyPress('Backspace')"
        class="bg-keyboard-functions rounded-md shadow hover:bg-hover flex items-center justify-center py-2 col-span-2 ml-2"
      >
        <soft-icon name="fa-left-long fa-solid"></soft-icon>
      </button>
    </div>

    <!-- Keyboard Row 4 -->
    <div class="col-span-11 grid grid-cols-11 gap-2 h-14">
      <button
        (click)="toggleNumericMode()"
        class="bg-keyboard-functions rounded-md shadow hover:bg-hover flex items-center justify-center py-2 col-span-2"
      >
        {{ isNumericMode() ? 'ABC' : '123' }}
      </button>

      <button
        (click)="keyPress('Space')"
        class="bg-surface rounded-md shadow hover:bg-hover flex items-center justify-center py-2 col-span-7"
      >
        &nbsp;
      </button>

      <button
        (click)="keyPress('Enter')"
        class="bg-keyboard-enter rounded-md shadow hover:bg-hover flex items-center justify-center py-2 col-span-2"
      >
        <soft-icon name="fa-arrow-turn-down-left fa-solid"></soft-icon>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #numpad>
  @let enterBackspaceButtons = inputType() === 'number' || inputType() === 'decimal';
  <!-- Numpad -->
  <div
    [ngClass]="enterBackspaceButtons ? 'flex' : 'hidden lg:flex'"
    class="flex-col gap-2 p-2 flex-[1]"
  >
    <div class="grid gap-2" [ngClass]="enterBackspaceButtons ? 'grid-cols-4' : 'grid-cols-3'">
      @for (row of displayedNumpadRowsCols().rows; track $index) {
        <div class="col-span-3 grid gap-2 h-14 grid-cols-3">
          @for (key of row; track $index) {
            <button
              [disabled]="isCommaDisabled(key)"
              (click)="keyPress(key)"
              class="bg-surface rounded-md shadow flex items-center justify-center py-2 px-6"
              [class.hover:bg-hover]="!isCommaDisabled(key)"
              [class.disabled-key]="isCommaDisabled(key)"
            >
              {{ key }}
            </button>
          }
        </div>
      }

      @if(enterBackspaceButtons) {
        <div class="row-start-1 col-start-4 row-span-4 grid gap-2 grid-rows-4">
          <button
            (click)="keyPress('Backspace')"
            class="bg-keyboard-functions rounded-md shadow hover:bg-hover flex items-center justify-center py-2"
          >
            <soft-icon name="fa-left-long fa-solid"></soft-icon>
          </button>

          <button
            (click)="keyPress('Enter')"
            class="bg-keyboard-enter rounded-md shadow hover:bg-hover flex items-center justify-center py-2 row-span-3"
          >
            <soft-icon name="fa-arrow-turn-down-left fa-solid"></soft-icon>
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
